export const REQUEST_CREATE_EXPERTISE_VICTIM =
  'REQUEST_CREATE_EXPERTISE_VICTIM';
export const REQUEST_GET_EXPERTISE_VICTIM = 'REQUEST_GET_EXPERTISE_VICTIM';
export const REQUEST_SET_EXPERTISE_VICTIM = 'REQUEST_SET_EXPERTISE_VICTIM';
export const REQUEST_CREATE_MISSION_POSTPONE =
  'REQUEST_CREATE_MISSION_POSTPONE';
export const REQUEST_GET_MISSION_POSTPONE = 'REQUEST_GET_MISSION_POSTPONE';
export const REQUEST_SET_MISSION_POSTPONE = 'REQUEST_SET_MISSION_POSTPONE';
export const REQUEST_GET_MISSION_POSTPONE_EXPERTISE =
  'REQUEST_GET_MISSION_POSTPONE_EXPERTISE';
export const REQUEST_SET_MISSION_POSTPONE_EXPERTISE =
  'REQUEST_SET_MISSION_POSTPONE_EXPERTISE';
export const REQUEST_UPDATE_MISSION_EXPERTISE =
  'REQUEST_UPDATE_MISSION_EXPERTISE';
export const REQUEST_UPDATE_MISSION_POSTPONE =
  'REQUEST_UPDATE_MISSION_POSTPONE';
export const REQUEST_REJECT_MISSION = 'REQUEST_REJECT_MISSION';
export const RESET_STORE_DETAILS_EXPERTISE = 'RESET_STORE_DETAILS_EXPERTISE';
